<template>
    <div class="case-report">
        <graph-triple-panel
            graph-title="三元组关系图"
            table-title="三元组数据表"
            :graph-data="graphData"
            :triples="triples"
            :page-size="10"
        />
    </div>
</template>

<script>
import GraphTriplePanel from './graph_triple_panel.vue';

export default {
    name: 'CaseReport',
    components: {
        GraphTriplePanel,
    },
    props: {
        chartData: {
            type: Object,
            default: () => ({ nodes: [], edges: [], triples: [] }),
        },
    },
    computed: {
        // 图谱固定展示前 50 个节点
        graphData() {
            const nodes = (this.chartData.nodes || []).slice(0, 50);
            const nodeIds = new Set(nodes.map((item) => item.id));
            const edges = (this.chartData.edges || []).filter(
                (item) => nodeIds.has(item.source) && nodeIds.has(item.target)
            );
            return { nodes, edges };
        },
        triples() {
            return this.chartData.triples || [];
        },
    },
};
</script>
